module.exports = __webpack_public_path__ + "media/1x1/mt-f6e3733c.svg";